import { h, Fragment } from "preact";
import { useState, useMemo, useEffect } from "preact/hooks";
import SwatchModalGroup from "./swatch-modal-group";
import { otherGroup } from "./otherGroup";
import sortMaterials from "../../helpers/sortMaterials/sortMaterials";
import pluralize from "../../helpers/pluralize";

export default function SwatchModal({
  products,
  limitEach,
  modalContent,
  localeStrings,
  swatchType,
}) {
  const [cartData, setCartData] = useState(window.cartData);

  useEffect(() => {
    const onCartUpdated = (e) => {
      setCartData(e.detail.cartData);
    };

    document.addEventListener("cart:updated", onCartUpdated);

    return () => document.removeEventListener("cart:updated", onCartUpdated);
  }, [setCartData]);

  const cartItems = cartData?.items || [];

  const swatchesInCart = cartItems.filter(
    (item) => item.properties?._swatch_type === swatchType,
  );

  const totalSwatchCount = swatchesInCart.reduce(
    (prev, curr) => prev + curr.quantity,
    0,
  );

  const productByGroup = useMemo(() => {
    const groups = {};
    products.forEach((product) => {
      if (!product.material_group) {
        // Group any missing groups under the option name
        product.material_group = otherGroup;
      }

      if (!(product.material_group in groups)) {
        groups[product.material_group] = [];
      }

      groups[product.material_group].push(product);
    });

    return groups;
  }, [products]);

  const openCart = () => {
    const onModalClose = () => {
      document.removeEventListener("markup-modal:closed", onModalClose);
      document.dispatchEvent(new CustomEvent("mini-cart:open"));
    };

    document.addEventListener("markup-modal:closed", onModalClose);
    document.dispatchEvent(new CustomEvent("markup-modal:close"));
  };

  return (
    <div className="pdp-swatch-modal__product-groups">
      {Object.entries(productByGroup)
        .sort(([groupA], [groupB]) => sortMaterials(groupA, groupB))
        .map(([groupName, products]) => (
          <SwatchModalGroup
            products={products}
            groupName={groupName}
            cartItems={cartItems}
            limitEach={limitEach}
            swatchType={swatchType}
          />
        ))}
      <div className="pdp-swatch-modal__footer">
        {swatchesInCart.length > 0 && (
          <div className="pdp-swatch-modal__swatches-in-cart-count">
            {pluralize(totalSwatchCount, localeStrings.samples_in_cart)}
          </div>
        )}

        <div className="pdp-swatch-modal__footer-actions">
          {modalContent.cta_copy && (
            <a
              href={modalContent.cta_url}
              className="link pdp-swatch-modal__cta"
            >
              {modalContent.cta_copy}
            </a>
          )}
          {swatchesInCart.length > 0 && (
            <button
              type="button"
              className="button button--black pdp-swatch-modal__checkout"
              onClick={openCart}
            >
              {localeStrings.checkout}
            </button>
          )}
          {swatchesInCart.length === 0 && (
            <button
              className="link pdp-swatch-modal__continue-shopping"
              data-close
            >
              {window.localeStrings.swatch_modal.continue_shopping}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
